/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../../../components/layout/Layout';
import FilterSidebar from '../../../../components/FilterSidebar';
import Icon from '../../../../components/elements/Icon';
import ReportFilter from '../../ReportFilter';
import ReportTab from './tabs/ReportTab';
import { DATE_MODE_FREQUENCY } from '../../ReportFilter';

const { REPORT_TYPES } = require('../../../../core/constants').default;

export default function () {
    const {
        eventsTabLoaded, eventsTabFilter, filterSidebar, filters,
    } = this.state;
    const { user, isFetching } = this.props;

    return (
        <Layout
            className="events"
            title={<div>Idle Report</div>}
            headerTitle={<div>Idle Report</div>}
            loading={isFetching}
        >
            <div className={`content-wrap${user?.userCompany?.current_alert ? '-with-banner' : ''}`}>
                <FilterSidebar displayFilter={filterSidebar} >
                    <ReportFilter 
                        onSubmit={this.onEventsTabFilterChange} 
                        filters={filters} 
                        showDivision
                        dateMode={DATE_MODE_FREQUENCY}
                        reportType={REPORT_TYPES.find((rt) => rt.link === 'true-idle-report').link}
                    />
                </FilterSidebar>
                <div 
                    className="content"
                    style={{ opacity: isFetching ? 0 : 1 }}
                >
                    <div className="content-inner">
                        <section className="section">
                            <div className="section__body">
                                <div className="section__action-bar" />
                                <ReportTab
                                    toggleFilterSidebar ={() => this.setState({filterSidebar: !filterSidebar})}
                                    eventsTabFilter={eventsTabFilter}
                                    setLoadedState={this.eventsTabLoaded}
                                    eventsTabLoaded={eventsTabLoaded}
                                    onTableChange={this.onEventsTabSortChange}
                                    onPageChange={this.onEventsTabPageChange} />
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </Layout>
    );
}
